import { render, staticRenderFns } from "./MessageCircleIcon.vue?vue&type=template&id=4191c46b"
import script from "./MessageCircleIcon.vue?vue&type=script&lang=js"
export * from "./MessageCircleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports